import { useRouter } from '@tanstack/react-router'
import { type RefObject, useEffect } from 'react'

export function useContentScroll(content: RefObject<HTMLElement | null>) {
  const router = useRouter()

  useEffect(
    () =>
      router.subscribe('onRendered', ({ fromLocation, toLocation }) => {
        if (fromLocation?.pathname === toLocation.pathname) return

        content.current?.scrollTo({ top: 0 })
      }),
    [router, content],
  )
}
